import React, { useState, useEffect } from "react";
import "./CategoriesModal.css";

/*
  Category Tooltips fetched dynammically from csv
  <input - csv file>
  <output - set of category names and descriptions displayed in a modal>
 */

export default function CategoriesTooltips({ selectedFileData }) {
  const [categoryNames, setCategoryNames] = useState([]); // category names from S3 array
  const [categoryTooltips, setCategoryTooltips] = useState([]); //tooltips present in the csv

  // UseEffect to get the category names
  useEffect(() => {
    if (selectedFileData) {
      const categories = selectedFileData
        .filter((item) => item["Category (per property)"].trim() !== "") // remove category names that are empty
        .map((item) => item["Category (per property)"].toUpperCase()); //convert them all to uppercase

      // Filter the category tooltips
      const tooltips = selectedFileData
        .filter((item) => item["Category Tooltip"].trim() !== "")
        .map((item) => item["Category Tooltip"]);

      // Remove duplicates
      const individualCategories = [...new Set(categories)]; //set of unique individual categories
      const individualTooltips = tooltips; // only the tooltips don't need to be unique

      // Category options for input form
      setCategoryNames(individualCategories);
      setCategoryTooltips(individualTooltips);
    }
  }, [selectedFileData]);

  return (
    <div className="categories-content">
      {categoryNames.map((title, i) => (
        <div key={i} className="cat-tooltip-block">
          <div className="general-tooltips-content">
            <p className="maps-text">
              <span>
                {title
                  .toLowerCase()
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")}
              </span>{" "}
              : {categoryTooltips[i]}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
